<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
</div>
